import { createMockProjectSnapshot } from '../fixtures/mock-project.js';
import { cloneValue } from '../domain/model-utils.js';

export class MockProjectRepository {
  /** @param {(() => Record<string, any>) | {snapshotFactory?: () => Record<string, any>}} [options] */
  constructor(options = {}) {
    this.snapshotFactory = typeof options === 'function'
      ? options
      : options.snapshotFactory || createMockProjectSnapshot;
  }

  /** @param {string} [projectId] */
  async getProjectSnapshot(projectId = '') {
    const snapshot = this.snapshotFactory();
    if (projectId && snapshot.project?.id !== projectId) {
      throw new Error(`Mock project not found: ${projectId}`);
    }
    return cloneValue(snapshot);
  }

  /** Alias used by small prototypes. @param {string} [projectId] */
  async getSnapshot(projectId = '') {
    return this.getProjectSnapshot(projectId);
  }

  async listProjects() {
    const snapshot = this.snapshotFactory();
    return [cloneValue(snapshot.project)];
  }
}
